import { Link, NavLink, useNavigate } from "react-router-dom";
import { Moon, Sun, Search, Flame } from "lucide-react";
import { useState } from "react";
import { useTheme } from "@/hooks/useTheme";
import { CATEGORIES } from "@/lib/api";

export const Logo = () => (
  <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2">
    <span className="grid h-10 w-10 place-items-center rounded-lg bg-primary font-serif-display text-2xl font-black text-white">N</span>
    <span className="font-serif-display text-2xl font-black tracking-tight sm:text-3xl">Notícia<span className="text-primary">365</span></span>
  </Link>
);

function CategoryNav() {
  const cls = ({ isActive }) => `shrink-0 px-3.5 py-3 text-[13px] font-extrabold uppercase tracking-wide transition-colors ${isActive ? "bg-black/25 text-white" : "text-white/90 hover:bg-black/15 hover:text-white"}`;
  return (
    <nav data-testid="category-menu" className="bg-primary">
      <div className="no-scrollbar mx-auto flex max-w-7xl overflow-x-auto px-2 sm:px-4 lg:px-6">
        <NavLink to="/" end className={cls} data-testid="cat-menu-ultima-hora"><Flame size={14} className="-mt-0.5 mr-1 inline" />Última Hora</NavLink>
        {CATEGORIES.map((c) => <NavLink key={c.slug} to={`/categoria/${c.slug}`} className={cls} data-testid={`cat-menu-${c.slug}`}>{c.name}</NavLink>)}
      </div>
    </nav>
  );
}

export function Header() {
  const { dark, toggle } = useTheme();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const today = new Date().toLocaleDateString("pt-MZ", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  return (
    <header className="sticky top-0 z-40 shadow-sm">
      <div className="border-b bg-background/95 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-6">
            <Logo />
            <span className="hidden font-mono-meta text-[11px] uppercase tracking-widest text-muted-foreground xl:block">{today}</span>
          </div>
          <form onSubmit={(e) => { e.preventDefault(); navigate(`/pesquisa?q=${encodeURIComponent(q)}`); }} className="relative hidden w-80 md:block">
            <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input data-testid="header-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquisar notícias…" className="h-10 w-full rounded-full border bg-muted/50 pl-10 pr-4 text-sm outline-none focus:border-primary" />
          </form>
          <div className="flex items-center gap-1">
            <button data-testid="header-search-btn" onClick={() => navigate("/pesquisa")} className="grid h-10 w-10 place-items-center rounded-full hover:bg-muted md:hidden" aria-label="Pesquisar"><Search size={19} /></button>
            <button data-testid="theme-toggle-btn" onClick={toggle} className="grid h-10 w-10 place-items-center rounded-full hover:bg-muted" aria-label="Tema">{dark ? <Sun size={19} /> : <Moon size={19} />}</button>
          </div>
        </div>
      </div>
      <CategoryNav />
    </header>
  );
}
